module["exports"] = [
  "Հյուսիսային",
  "Արևելյան",
  "Արևմտյան",
  "Հարավային",
  "Նոր"
];
